import { Button as MantineButton, type ButtonProps as MantineButtonProps } from '@mantine/core';
import { forwardRef, type ButtonHTMLAttributes } from 'react';

export type ButtonProps = MantineButtonProps & ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(props, ref) {
  return <MantineButton ref={ref} {...props} />;
});
